export const nonDeviceDefaultStyles = {
  color: '#8296a0',
  background: '',
  fontSize: '14',
};

export default {
  override: {
    x: 10,
    y: 220,
    z: 0,
    length: 100,
    size: 50,
    label: 'Override',
    ...nonDeviceDefaultStyles,
  },
  abort: {
    x: 10,
    y: 280,
    z: 0,
    length: 100,
    size: 50,
    label: 'Abort',
    ...nonDeviceDefaultStyles,
  },
  demo: {
    x: 10,
    y: 340,
    z: 0,
    length: 100,
    size: 50,
    label: 'Demo',
    ...nonDeviceDefaultStyles,
  },
  material: {
    x: 10,
    y: 400,
    z: 0,
    length: 100,
    size: 50,
    label: 'Material',
    ...nonDeviceDefaultStyles,
  },
  batch: {
    x: 10,
    y: 460,
    z: 0,
    length: 100,
    size: 50,
    label: 'Batch',
    ...nonDeviceDefaultStyles,
  },
  discharge: {
    x: 10,
    y: 520,
    z: 0,
    length: 100,
    size: 50,
    label: 'Discharge',
    ...nonDeviceDefaultStyles,
  },
  rateplus: {
    x: 60,
    y: 580,
    z: 0,
    length: 50,
    size: 50,
    label: 'Plus',
    ...nonDeviceDefaultStyles,
  },
  rateminus: {
    x: 10,
    y: 580,
    z: 0,
    length: 50,
    size: 50,
    label: 'Minus',
    ...nonDeviceDefaultStyles,
  },
  holdfeed: {
    x: 10,
    y: 640,
    z: 0,
    length: 100,
    size: 50,
    label: 'Hold Feed',
    ...nonDeviceDefaultStyles,
  },
  stop: {
    x: 10,
    y: 700,
    z: 0,
    length: 100,
    size: 50,
    label: 'Stop',
    ...nonDeviceDefaultStyles,
  },
  washout: {
    x: 10,
    y: 760,
    z: 0,
    length: 100,
    size: 50,
    label: 'Washout',
    ...nonDeviceDefaultStyles,
  },
};
